











import PhoneBlock from '@/components/Phone/PhoneBlock.vue'
import UserAvatar from '@/components/User/UserAvatar.vue'

export default {
  components: {
    PhoneBlock,
    UserAvatar,
  },

  data() {
    const users: unknown[] = []
    for (let i = Math.trunc((Math.random() * 10) % 10); i; i--) {
      users.push({})
    }
    return {
      users,
    }
  },
}
